import { useState, useMemo } from 'react';
import { useProductByHandle } from '@backpackjs/storefront';
import { Section } from '@snippets';
import { ProductContext } from './ProductContext';
import { Main } from './Main';
import { useInitSelectedVariant } from './useInitSelectedVariant';

import { Schema } from './Product.schema';

export function Product({ cms }) {
  const [initialProductHandle, setInitialProductHandle] = useState(null);
  const { product } = useProductByHandle({
    handle: initialProductHandle || cms?.product?.handle || '',
  });
  const { section } = cms;
  const anyOf = {
    productUpsells: null,
    videoWise: null,
  };
  const rebuyProducts = null;

  const {
    selectedOptions,
    selectedVariant,
    setSelectedOptions,
    selectedMedia,
  } = useInitSelectedVariant(product);

  const productData = useMemo(() => {
    return {
      setInitialProductHandle,
      product,
      selectedVariant,
      selectedOptions,
      setSelectedOptions,
      selectedMedia,
    };
  }, [product, selectedVariant, selectedOptions, selectedMedia]);

  if (!product) {
    return null;
  }
  return (
    <ProductContext.Provider value={productData}>
      <Section section={section}>
        <Main
          productUpsells={anyOf.productUpsells}
          rebuyProducts={rebuyProducts}
          videoWise={anyOf?.videoWise}
        />
      </Section>
    </ProductContext.Provider>
  );
}

Product.displayName = 'Product';
Product.Schema = Schema;
